/* eslint-disable jsx-a11y/anchor-is-valid */

import React, { useEffect, useRef, useState } from "react";
import ic_sun_big_circle from "../../assets/images/pictures/icon/ic_sun_big_circle.svg";
import sealing_header from "../../assets/images/pictures/e-sealing-header.png";
import ic_check_mark_circle from "../../assets/images/pictures/icon/ic_check-mark_circle.svg";
import ic_2_persons_circle from "../../assets/images/pictures/icon/ic_2_persons_circle.svg";
import ic_plant_circle from "../../assets/images/pictures/icon/ic_plant_circle.svg";
import ic_thunder_big_circle from "../../assets/images/pictures/icon/ic_thunder_big_circle.svg";
import ic_security from "../../assets/images/pictures/icon/ic_security.svg";
import ic_contact from "../../assets/images/pictures/icon/ic_contact.svg";
import ic_clock from "../../assets/images/pictures/icon/ic_clocks.svg";
import ic_calendar from "../../assets/images/pictures/icon/ic_calendar.svg";
import ic_control_point from "../../assets/images/pictures/icon/ic_control-point.svg";
import ic_download_white from "../../assets/images/pictures/icon/ic_download-white.svg";
import gopaperless_service from "../../assets/images/pictures/solutions-footer.png";
import { motion } from "framer-motion";
import { useTranslation } from "react-i18next";
import routeVariants from "../../assets/animates/routeVariants";
import Modal from "../global/Modal";
import cd from "../../assets/images/logos/e/cdlogo.png";
import gf from "../../assets/images/logos/e/gf-logo.png";
import moki from "../../assets/images/logos/e/moki.png";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

const ESealingApiContent = (props) => {
  const [modalOpen, setModalOpen] = useState(false);

  useEffect(() => {
    if (modalOpen === true) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "auto";
    }
  }, [modalOpen]);

  const modalRef = useRef(null);

  const handleOverlayClick = (event) => {
    if (modalRef.current && !modalRef.current.contains(event.target)) {
      setModalOpen(false);
    }
  };

  document.onkeydown = function (evt) {
    if (evt.code === "Escape") {
      setModalOpen(false);
    }
  };

  const { t } = useTranslation();

  useEffect(() => {
    if (props.following === true) {
      document.getElementById("e-sealing-api").classList.add("active", "in");
    } else {
      document.getElementById("e-sealing-api").classList.remove("active", "in");
    }
  }, [props.following]);

  return (
    <>
      <motion.div
        variants={routeVariants}
        initial="initial"
        animate="final"
        className="tab-pane fade"
        id="e-sealing-api"
      >
        <div className="container pt-50 pb-50">
          <div className="row api-solutions">
            <div className="col-sm-6 pl-md-0 pt-50">
              <img
                width="64"
                height="64"
                src={ic_sun_big_circle}
                className="attachment-full size-full"
                alt=""
                decoding="async"
                loading="lazy"
                data-no-retina=""
              />
              <h2 className="heading font-weight-bold">
                {t(
                  "e-sealing-api-page.e-sealing-api-page-content.content-1.heading"
                )}
              </h2>
              <div className="subheading">
                <p>
                  {t(
                    "e-sealing-api-page.e-sealing-api-page-content.content-1.description"
                  )}
                </p>
              </div>
              <ul className="list-inline">
                <li>
                  <img className="client-s-none-width img-bw" src={cd} alt="" />
                </li>
                <li>
                  <img className="client-s-none-width img-bw" src={gf} alt="" />
                </li>
                <li>
                  <img
                    className="client-s-none-width img-bw"
                    src={moki}
                    alt=""
                  />
                </li>
              </ul>
            </div>
            <div className="col-sm-6 pr-md-0 ">
              <img
                src={sealing_header}
                className="img-responsive"
                alt=""
                decoding="async"
                loading="lazy"
                width="400"
              />
            </div>
          </div>
        </div>

        <div className="bg-color py-100">
          <div className="container api-solutions ">
            <div className="row">
              <div className="col-sm-12 px-md-0">
                <div className="rectangle"></div>
                <h2 className="font-weight-bold">
                  {t(
                    "e-sealing-api-page.e-sealing-api-page-content.content-2.big-heading"
                  )}
                </h2>
              </div>
            </div>
            <div className="row">
              <div className="col-sm-4 mb-30 pl-md-0">
                <img
                  width="40"
                  height="40"
                  src={ic_check_mark_circle}
                  className="attachment-full size-full"
                  alt=""
                  decoding="async"
                  loading="lazy"
                  data-no-retina=""
                />{" "}
                <h3>
                  {t(
                    "e-sealing-api-page.e-sealing-api-page-content.content-2.small-heading-1"
                  )}
                </h3>
                <p>
                  {t(
                    "e-sealing-api-page.e-sealing-api-page-content.content-2.small-description-1"
                  )}
                </p>
              </div>
              <div className="col-sm-4 mb-30">
                <img
                  width="40"
                  height="40"
                  src={ic_2_persons_circle}
                  className="attachment-full size-full"
                  alt=""
                  decoding="async"
                  loading="lazy"
                  data-no-retina=""
                />
                <h3>
                  {t(
                    "e-sealing-api-page.e-sealing-api-page-content.content-2.small-heading-2"
                  )}
                </h3>
                <p>
                  {t(
                    "e-sealing-api-page.e-sealing-api-page-content.content-2.small-description-2"
                  )}
                </p>
              </div>
              <div className="col-sm-4 mb-30 pr-md-0">
                <img
                  width="40"
                  height="40"
                  src={ic_plant_circle}
                  className="attachment-full size-full"
                  alt=""
                  decoding="async"
                  loading="lazy"
                  data-no-retina=""
                />
                <h3>
                  {t(
                    "e-sealing-api-page.e-sealing-api-page-content.content-2.small-heading-3"
                  )}
                </h3>
                <p>
                  {t(
                    "e-sealing-api-page.e-sealing-api-page-content.content-2.small-description-3"
                  )}
                </p>
              </div>
            </div>
          </div>
        </div>

        <div className="container mt-100 api-solutions api-solutions--features">
          <div className="row">
            <div className="text-center col-xs-12">
              <img
                width="64"
                height="64"
                src={ic_thunder_big_circle}
                className="attachment-full size-full"
                alt=""
                decoding="async"
                loading="lazy"
                data-no-retina=""
              />
              <h2 className="font-weight-bold">
                {t(
                  "e-sealing-api-page.e-sealing-api-page-content.content-3.big-heading"
                )}
              </h2>
            </div>
          </div>
          <div className="row">
            <div className="col-sm-4">
              <div className="media-list">
                <div className="media text-center">
                  <div className="media-body">
                    <img
                      width="24"
                      height="24"
                      src={ic_security}
                      className="attachment-full size-full"
                      alt=""
                      decoding="async"
                      loading="lazy"
                      data-no-retina=""
                    />
                    <h4>
                      {t(
                        "e-sealing-api-page.e-sealing-api-page-content.content-3.small-heading-1"
                      )}
                    </h4>
                    <p>
                      {t(
                        "e-sealing-api-page.e-sealing-api-page-content.content-3.small-description-1"
                      )}
                    </p>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-sm-4">
              <div className="media-list">
                <div className="media text-center">
                  <div className="media-body">
                    <img
                      width="24"
                      height="24"
                      src={ic_contact}
                      className="attachment-full size-full"
                      alt=""
                      decoding="async"
                      loading="lazy"
                      data-no-retina=""
                    />
                    <h4>
                      {t(
                        "e-sealing-api-page.e-sealing-api-page-content.content-3.small-heading-2"
                      )}
                    </h4>
                    <p>
                      {t(
                        "e-sealing-api-page.e-sealing-api-page-content.content-3.small-description-2"
                      )}
                    </p>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-sm-4">
              <div className="media-list">
                <div className="media text-center">
                  <div className="media-body">
                    <img
                      width="24"
                      height="24"
                      src={ic_clock}
                      className="attachment-full size-full"
                      alt=""
                      decoding="async"
                      loading="lazy"
                      data-no-retina=""
                    />
                    <h4>
                      {t(
                        "e-sealing-api-page.e-sealing-api-page-content.content-3.small-heading-3"
                      )}
                    </h4>
                    <p>
                      {t(
                        "e-sealing-api-page.e-sealing-api-page-content.content-3.small-description-3"
                      )}
                    </p>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-sm-4">
              <div className="media-list">
                <div className="media text-center">
                  <div className="media-body">
                    <img
                      width="24"
                      height="24"
                      src={ic_calendar}
                      className="attachment-full size-full"
                      alt=""
                      decoding="async"
                      loading="lazy"
                      data-no-retina=""
                    />
                    <h4>
                      {t(
                        "e-sealing-api-page.e-sealing-api-page-content.content-3.small-heading-4"
                      )}
                    </h4>
                    <p>
                      {t(
                        "e-sealing-api-page.e-sealing-api-page-content.content-3.small-description-4"
                      )}
                    </p>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-sm-4">
              <div className="media-list">
                <div className="media text-center">
                  <div className="media-body">
                    <img
                      width="24"
                      height="24"
                      src={ic_control_point}
                      className="attachment-full size-full"
                      alt=""
                      decoding="async"
                      loading="lazy"
                      data-no-retina=""
                    />
                    <h4>
                      {t(
                        "e-sealing-api-page.e-sealing-api-page-content.content-3.small-heading-5"
                      )}
                    </h4>
                    <p>
                      {t(
                        "e-sealing-api-page.e-sealing-api-page-content.content-3.small-description-5"
                      )}
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="api-solutions bg-color--img-overlap mt-50 bg-color">
          <div className="container identification-footer">
            <div className="row">
              <div className="col-sm-6 pl-md-0">
                <h2 className="heading font-weight-bold">
                  {t(
                    "e-sealing-api-page.e-sealing-api-page-content.content-4.heading"
                  )}
                </h2>
                <div className="subheading">
                  <p>
                    {t(
                      "e-sealing-api-page.e-sealing-api-page-content.content-4.description"
                    )}
                  </p>
                </div>
                <a                 href="/uploads/BẢNG GIÁ DỊCH VỤ GOPAPERLESS.pdf"
  download="BẢNG GIÁ DỊCH VỤ GOPAPERLESS.pdf" className="btn-primary mr-16">
                  <img
                    width="18"
                    height="18"
                    src={ic_download_white}
                    className="attachment-full size-full mt--3 mr-5"
                    alt=""
                    decoding="async"
                    loading="lazy"
                    data-no-retina=""
                  />
                  {t(
                    "e-sealing-api-page.e-sealing-api-page-content.content-4.button-download-pricing"
                  )}
                </a>

                <a
                  href="javascript:;"
                  onClick={() => setModalOpen(true)}
                  className="btn-secondary"
                >
                  {t(
                    "e-sealing-api-page.e-sealing-api-page-content.content-4.button-contact-us"
                  )}
                </a>
              </div>
              <div className="col-sm-6 pl-md-0">
                <img
                  src={gopaperless_service}
                  width="400px"
                  className="bg-color--img-overlap__img img-responsive"
                  alt=""
                  decoding="async"
                  loading="lazy"
                />
              </div>
            </div>
          </div>
        </div>
      </motion.div>
      {modalOpen && (
        <Modal
          setOpenModal={setModalOpen}
          handleOverlayClick={handleOverlayClick}
          modalRef={modalRef}
          heading={t("modal.heading-found-solution-fit")}
          description={t("modal.description-get-started")}
          type="Solutions - E Sealing API - e-Sealing in your e-service"
        />
      )}
      <ToastContainer />
    </>
  );
};

export default ESealingApiContent;
